module.exports = __webpack_public_path__ + "static/img/3-中建材.9b56b466.png";